import { HStack } from '@genial/components';
import { BoxRadius, Spacing, Typography } from '@genial/design-tokens';
import { Text, Pressable, Flex, IStackProps } from 'native-base';
import React from 'react';

interface ItemTagTriggerButtonTextProps extends IStackProps {
  children: React.ReactNode;
}

interface ItemTagTriggerButtonProps {
  tags: string[];
  triggerProps?: any;
  onOpen: () => void;
}

const gapStyle = { gap: 4 };

const ItemTagTriggerButtonText: React.FC<ItemTagTriggerButtonTextProps> = ({
  children,
  ...rest
}) => {
  return (
    <HStack
      {...rest}
      alignItems="center"
      bg={'feedback.gen.lightest'}
      px={Spacing['inline.nano']}
      py={Spacing['inline.quarck']}
      borderRadius={BoxRadius.xs}>
      <Text
        flex={1}
        numberOfLines={1}
        color="brand.tertiary.dark"
        variant="semibold"
        fontSize={Typography['fontsize.md']}>
        {children}
      </Text>
    </HStack>
  );
};

export const ItemTagTriggerButton: React.FC<ItemTagTriggerButtonProps> = ({
  tags,
  triggerProps,
  onOpen,
}) => {
  if (!tags?.length) {
    return (
      <Pressable {...triggerProps}>
        <Text color="neutral.darkest" variant="regular" fontSize={Typography['fontsize.md']}>
          --
        </Text>
      </Pressable>
    );
  }

  const firstItemLable = tags[0];

  const itemCount = tags.reduce((acc, _, index) => {
    if (index > 0) {
      acc += 1;
    }
    return acc;
  }, 0);

  return (
    <Pressable {...triggerProps} onPress={onOpen}>
      <Flex style={gapStyle} flexWrap="wrap" flexDirection="row" alignItems="center">
        <Text
          numberOfLines={1}
          fontSize={Typography['fontsize.md']}
          color="neutral.darkest"
          variant="regular">
          {firstItemLable}
        </Text>
        {itemCount > 0 && <ItemTagTriggerButtonText>+{itemCount}</ItemTagTriggerButtonText>}
      </Flex>
    </Pressable>
  );
};
